import React from 'react';

export default function AboutSection() {
  return (
    <section className="bg-gray-100 py-10">
      <div className="mx-auto flex justify-between items-center px-4 md:px-8">
        <div className="w-full">
          {/* Title */}
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-[#2c2087] inline-block border-b-[3px] border-[#2c2087] pb-2">
              Explore SPSU
            </h1>
          </div>

          {/* Content Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Left Section (Text + Large Image) */}
            <div className="md:col-span-2 flex flex-col">
              {/* Info Box */}
              <div className="bg-black text-white p-6">
                <p className="text-lg leading-relaxed">
                  <strong>SPSU</strong> has been ranked as the No. 1 university
                  in the Mewar region. It is ranked 4th in Rajasthan and 23rd in
                  India by EW Ranking 2022. SPSU has been awarded Diamond Band
                  Rating with A+ Grade in the OBE World rankings 2022. SPSU
                  offers 6 specializations across the School of Engineering and
                  Management, in partnership with leading corporates.
                </p>
              </div>

              {/* Image Container for Equal Height */}
              <div className="flex">
                <img
                  src="assets/about-us-image-1.png"
                  alt="Graduation Ceremony"
                  className="w-full h-80 object-cover shadow-md"
                />
              </div>
            </div>

            {/* Right Section (Smaller Image) */}
            <div className="flex flex-col">
              <img
                src="assets/about-us-image.png"
                alt="University Building"
                className="w-full h-96 md:h-[30rem] object-bottom object-cover border-[4px] border-black shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
